module.exports = __webpack_public_path__ + "img/concorde-75.602903c6.png";